import z from "zod";

export const SmsVerifiedEventSchema = z.object({
  userId: z.string(),
  teamId: z.string(),
  phoneNumber: z.string(),
  creditGranted: z.boolean(),
  verifiedAt: z.string().datetime(),
});

export type SmsVerifiedEvent = z.infer<typeof SmsVerifiedEventSchema>;

export type HandleSmsVerifiedNotificationInput = {
  event: SmsVerifiedEvent;
};

export interface SmsVerifiedNotificationServiceInterface {
  handleSmsVerified(input: HandleSmsVerifiedNotificationInput): Promise<void>;
}
